import { ChangePartnershipTierSelectorItem } from "./variants/Change"
import { NewPartnershipTierSelectorItem } from "./variants/New"
import { PartnershipTierSelectorItemApplylistFragment } from "__generated__/PartnershipTierSelectorItemApplylistFragment"
import { PartnershipTierSelectorItemTierFragment } from "__generated__/PartnershipTierSelectorItemTierFragment"

type PartnershipTierSelectorItemProps = {
    applylist: PartnershipTierSelectorItemApplylistFragment
    partnershipTier: PartnershipTierSelectorItemTierFragment
    referrer?: "jobs" | "talent"
}

export const PartnershipTierSelectorItem = (
    props: PartnershipTierSelectorItemProps
) => {
    const Item =
        props.applylist.partnership &&
        !props.applylist.partnership.canRepurchase
            ? ChangePartnershipTierSelectorItem
            : NewPartnershipTierSelectorItem
    return <Item {...props} />
}
